import React, { useState, useRef } from 'react';
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';
import { useCommon } from '../../../Hooks/Common/useCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from "react-multi-date-picker";
import { useExtendRequestList } from '../../../Hooks/Features/Timesheet/useExtendRequestList';
import CommonFilterDropdown from '../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';

function ExtendRequestList() {
  const { columns, rowData, tagRef, loader, filterValues, setFilterValues, getTimesheetlist, dropDownOption, handleStatusChange, dynamicStatusOptions, confirmAction, showPopup, setShowPopup, pendingAction, setRadioSelection, handleRequest, selectedRow } = useExtendRequestList();
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  return (
    <div ref={() => checkPermission("timesheet_li", tagRef)}>
      <div ref={tagRef} id='{"tabname": "timesheet_li", "data": "timesheet_extend_request_tab"}' >
        <div className="d-flex align-items-center justify-content-between gap-3 w-100 my-3">
          <div className="d-flex align-items-center gap-2 flex-grow-1">
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2">
            <button className="sk-btn sk-btn-primary" onClick={() => getTimesheetlist()} title="Refresh">
              <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
            </button>
            <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            <div className="d-flex justify-content-end gap-2 ">
              {
                ((filterValues?.status?.request_status_key === "is_pending" || filterValues?.status?.request_status_key === "is_rejected") || (filterValues?.status?.request_status_key === "is_approved" && dropDownOption?.isGovernanceExcellence)) && <button className="sk-btn sk-btn-primary " onClick={() => handleRequest("is_approved", selectedRow, true)}>Approve All</button>
              }
              {
                (filterValues?.status?.request_status_key === "is_pending" || filterValues?.status?.request_status_key === "is_approved") && <button className="sk-btn sk-btn-danger" onClick={() => handleRequest("is_rejected", selectedRow, true)}>Reject All</button>
              }
            </div>
          </div>
        </div>
        <CommanDialog
          visible={showPopup}
          message={`Are you sure you want to ${pendingAction?.status === 'is_approved' ? 'approve' : 'reject'} this request?`}
          handleClose={() => { setShowPopup(false); setRadioSelection(null) }}
          handleFun={confirmAction}
        />
        <div style={{ height: "calc(100vh - 120px)", overflowY: "auto", width: "100%", maxWidth: "", overflowX: "" }}>
          <CommonGrid columns={columns} data={[{
            id: 'all',
            title: "",
            children: rowData
          }]} loader={loader} headerHeight={50} rowHeight={35} />
        </div>
      </div>

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValues((prev) => ({
                  ...prev,
                  hoveredRange: [null, null],
                  all_users: [],
                  status: dropDownOption?.statusOptions?.[0],
                  apiCall: true
                }));
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Date Picker Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Date Range</div>
                <DatePicker
                  ref={datePickerRef}
                  value={filterValues?.hoveredRange}
                  onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, hoveredRange: date, isChange: true }));
                    if (date && date.length === 2) {
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  range
                  rangeHover
                  style={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                  inputClass="w-100 sk-input-dd"
                  placeholder="Select Date"
                />
              </div>

              {/* Users Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Dimensions</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "all_users", label: "Users", col: 12 }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues}
                />
              </div>

              {/* Status Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Status</div>
                <div className='sk-segment-control mb-3'>
                  {dynamicStatusOptions?.map((item) => (
                    <button
                      key={item.request_status_id}
                      type="button"
                      className={`sk-segment-btn ${filterValues.status?.request_status_id === item.request_status_id ? 'active' : ''}`}
                      onClick={() => handleStatusChange({ target: { value: item.request_status_id } }, item?.request_status_key)}
                    >
                      {item.request_status_name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              getTimesheetlist();
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExtendRequestList;


